import { getLocaleNumericFormat } from '@philips-internal/oswald-ui-model/lib/generators/numeric/numeric-utils.js';
function isDecimalNumber(value) {
    if (value === undefined || value === null || value === '') {
        return false;
    }
    const valueNumber = Number(value);
    return !isNaN(valueNumber) && !Number.isInteger(valueNumber);
}
function formatDecimalValue(value, decimalSeparator) {
    if (value === undefined || value === null || value === '') {
        return String(value);
    }
    const DECIMAL_SEPARATOR = decimalSeparator ?? getLocaleNumericFormat().DECIMAL_SEPARATOR;
    const stringValue = String(value);
    if (stringValue.includes(DECIMAL_SEPARATOR) && !stringValue.includes('.')) {
        return stringValue;
    }
    if (stringValue.includes('.') && isDecimalNumber(value)) {
        const parts = stringValue.split('.');
        if (parts.length === 2 && parts[1].length > 0) {
            return `${parts[0]}${DECIMAL_SEPARATOR}${parts[1]}`;
        }
    }
    return stringValue;
}
function formatDecimalValues(values) {
    const decimalSeparator = getLocaleNumericFormat().DECIMAL_SEPARATOR;
    for (const field in values) {
        if (Object.hasOwn(values, field)) {
            const value = values[field];
            const formattedValue = formatDecimalValue(value, decimalSeparator);
            if (formattedValue !== String(value)) {
                values[field] = formattedValue;
            }
        }
    }
}
const NumericFormatterUtil = {
    formatDecimalValue,
    formatDecimalValues,
};
export default NumericFormatterUtil;
//# sourceMappingURL=numeric-formatter-util.js.map